import React from "react";

const HomeCard = ({ image, title, content }) => {
    return (
        <div className="pb-[3rem] flex-auto home__distinction--card">
            <div className="bg-[#FBF7FF] shadow-btn rounded-[16px] flex flex-row justify-center items-center p-6 gap-x-2 h-full">
                <div className="w-full flex justify-center items-center">
                    <img className="" src={image} alt="" />
                </div>
                <div className="flex flex-col">
                    <p className="text-[1.8rem] mb-2 font-bold text-primary-dark">
                        {title}
                    </p>
                    <p className="text-[14px] leading-10">{content}</p>
                </div>
            </div>
        </div>
    );
};

export default HomeCard;
